import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import { Status } from '../../classess/status/status';

import { GlobalFormats } from '../../classess/main/globalFormats';

import StatusAddEditDetails from './StatusAddEditDetails';
import {
    awaitDelayAsync, getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { StatusService } from '../../services/status/StatusService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { html, colors, icons, images, labels, messages, } = settings;

const currentMethod = 'Status';

export default function StatusView({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const dtStatusId = 'dtStatus';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
    });
    const isMount = useRef(true);
    const [status, setStatus] = useState(Status?.getClass({}, false));
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageId: languageObj?.id,
        dtStatusId: dtStatusId,
        dtStatusRowId: 0,
    });
    const controls = {
        buttons: {
            addEditDetails: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddEditDetails',
            },
        },
        icons: {
            addEditDetails: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addEditDetails: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region status
    const getAddStatus = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddStatus';
        try {
            if (e.preventDefault) e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
                add: true,
            }));

            setStatus(prev => Status?.getClass({}, false));
            await awaitDelayAsync({
                delayTime: settings?.timers?.twoNanoSeconds,
            });

            if (isMount.current) {
                setModalObj(prev => ({
                    ...prev,
                    $: $,
                    type: 0,
                    auth: auth,
                    showModal: true,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({
                ...prev,
                showLoading: false,
                add: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getEditDetailsStatus = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getEditDetailsStatus';
        try {
            if (e.preventDefault) e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
            }));

            //#region status (get byid)
            response = await StatusService.getById({
                auth,
                id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const statusData = response?.result?.status?.id > 0 ?
                Status?.getClass(response?.result.status, false) :
                null;
            //#endregion status (get byid)

            if (!statusData) {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/>${labels?.name?.[languageObj?.id]}: <b>${description}</b><br/>`;
                return;
            }

            if (isMount.current) {
                setStatus(prev => statusData);

                setModalObj(prev => ({
                    ...prev,
                    $: $,
                    type: 1,
                    auth: auth,
                    showModal: true,
                    dtStatusRowId: rowId,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const deleteStatus = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteStatus';
        try {
            if (e.preventDefault) e?.preventDefault?.();

            const msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}<br/>`,
                two: `${labels?.status?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            const swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        preConfirmResponse = await StatusService?.deleteAsync({
                            auth,
                            id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;

                        $(`#${dtStatusId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }
    //#endregion status

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            if (isMount.current) setShowData(true);

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (status)
                response = await StatusService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const statusData = response?.result.status;
                //#endregion get data (status)

                //#region set datatable
                if (!isUndNullEmp({ data: statusData, subMethod: currentMethod })?.result && statusData.length > 0) {
                    response = setDataInDataTable({
                        data: statusData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                response = getResponse({ type: 1 });
                response.isSuccess = false;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtStatusId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '95%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtStatusId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtStatusId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtStatusId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getEditDetailsStatus({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            deleteStatus({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region variables

            let statusDt = [];

            //#endregion variables

            //#region process
            data.forEach((status) => {
                const modelStatus = Status?.getClass(status, false);
                const processButtons = [];
                statusDt.push([
                    modelStatus.name,
                    getProcessButtons({
                        id: modelStatus.id,
                        description: modelStatus.name,
                        showDetails: false,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: false,
                        showDelete: true,
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: true,
                        showEdit: true,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: true,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtStatusId}`)?.DataTable()?.rows?.add(statusDt)?.draw(true);

            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion data

    //#region effects
    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion effects
    //#endregion methods
    //#region render
    return (
        <div>
            <Menu viewName={settings?.app?.views?.settings?.settings} process={settings?.app?.views?.status?.status} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.status?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.status?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.status?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.status} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.status?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.listUl} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Maintenance'}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className='ml-auto'>
                                                        <button id={controls?.buttons?.addEditDetails?.id}
                                                            type='button'
                                                            className={process.add ? `${controls?.buttons?.addEditDetails?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addEditDetails?.defaultClass}
                                                            disabled={process.add}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            onClick={(e) => getAddStatus({
                                                                e: e,
                                                                subMethod: controls?.buttons?.addEditDetails?.id
                                                            })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {!process.add ? (
                                                                <i id={controls?.icons?.addEditDetails?.id} className={controls?.icons?.addEditDetails?.defaultClass} />
                                                            ) : (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtStatusId} languageObj={languageObj} />
                                            </div>

                                            <div className='card-footer text-right' />
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>
            </div>

            {modalObj?.showModal && (
                <StatusAddEditDetails modalObj={modalObj}
                    setModalObj={setModalObj}
                    status={status}
                    setStatus={setStatus} />
            )}
        </div>
    )
    //#endregion render
}